// Shared session-form constants & helpers, used by both the public teacher
// form and the admin paper-session transcription page.

export const PILLARS = [
  {
    name: "Engagement",
    descriptors: [
      { key: "listening", label: "Listening" },
      {
        key: "attempting",
        label: "Attempting",
        sub: "physically trying movements during the session",
      },
      { key: "onTask", label: "On Task" },
      { key: "responding", label: "Responding" },
    ],
  },
  {
    name: "Behaviour",
    descriptors: [
      { key: "safe", label: "Safe" },
      { key: "respectful", label: "Respectful" },
      { key: "managing", label: "Managing" },
      { key: "adjusting", label: "Adjusting" },
    ],
  },
  {
    name: "Collective Energy",
    descriptors: [
      { key: "effort", label: "Effort" },
      { key: "encouraging", label: "Encouraging" },
      { key: "together", label: "Together" },
      { key: "uplifting", label: "Uplifting" },
    ],
  },
];

export const DESCRIPTOR_KEYS = PILLARS.flatMap((p) => p.descriptors.map((d) => d.key));

export const SCORE_VALUES = [0, 3, 5, 6];
export const SCORE_LABEL = { 0: "Not", 3: "Inconsistent", 5: "Mostly", 6: "Clear" };
export const CONTINUITY = ["Steady Session", "Uneven Session", "Disrupted Session"];
export const VIEW_OPTIONS = ["Very Clear", "Mostly Clear", "Some Limits", "Limited View"];
export const PROGRAMMES = [
  "Taster",
  "1-Week Ignite",
  "5-Week Programme",
  "Term Programme",
  "Cluster Model",
  "Year Programme",
];
export const TERMS = ["Term 1", "Term 2", "Term 3", "Term 4"];
export const YEAR_LEVELS = [
  "Year 1", "Year 2", "Year 1/2",
  "Year 3", "Year 4", "Year 3/4", "Year 1/2/3",
  "Year 5", "Year 6", "Year 4/5", "Year 5/6", "Year 4/5/6",
  "Year 7", "Year 8", "Year 7/8",
  "Year 9", "Year 10", "Year 9/10",
  "Other",
];

export const REQUIRED_KEYS = [
  "school", "year_level", "class_name", "teacher_name", "role",
  "session_week", "date", "term", "programme_type",
  "expected_on_roll", "present_learners", "continuity", "session_view",
];

export const todayISO = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const emptyScores = () =>
  DESCRIPTOR_KEYS.reduce((acc, k) => ({ ...acc, [k]: null }), {});

export const emptyForm = () => ({
  school: "",
  school_other: "",
  year_level: "",
  class_name: "",
  teacher_name: "",
  role: "Teacher",
  session_week: "",
  date: todayISO(),
  term: "Term 1",
  programme_type: "",
  scores: emptyScores(),
  expected_on_roll: "",
  present_learners: "",
  continuity: "",
  session_view: "",
  comment: "",
});

export const isFormComplete = (form) => {
  for (const k of REQUIRED_KEYS) {
    if (form[k] === "" || form[k] === null || form[k] === undefined) return false;
  }
  if (form.school === "__other__" && !form.school_other.trim()) return false;
  if (Object.values(form.scores).some((v) => v === null || v === undefined)) return false;
  return true;
};

export const isInvalidAttendance = (form) => {
  const e = Number(form.expected_on_roll);
  const p = Number(form.present_learners);
  if (form.expected_on_roll === "" || form.present_learners === "") return false;
  return p > e || e <= 0;
};

export const toApiPayload = (form) => ({
  school: form.school,
  school_other: form.school === "__other__" ? form.school_other.trim() : null,
  year_level: form.year_level,
  class_name: form.class_name.trim(),
  teacher_name: form.teacher_name.trim(),
  role: form.role,
  session_week: form.session_week.trim(),
  date: form.date,
  term: form.term,
  programme_type: form.programme_type,
  scores: form.scores,
  expected_on_roll: Number(form.expected_on_roll),
  present_learners: Number(form.present_learners),
  continuity: form.continuity,
  session_view: form.session_view,
  comment: form.comment.trim(),
});
